import { useQuery } from '@tanstack/react-query';

import { fetchVenues, fetchBrandVenues, MERCHANT_ENTERPRISE_SERVICE } from 'apis/enterprise/api';
import { Brand } from 'apis/enterprise/types';

async function fetchVenuesData(venuesIds: string[]) {
  const { results } = await fetchVenues(venuesIds);
  return results;
}

export default function useGetBrandVenues({ brand }: { brand: Brand | undefined }) {
  const {
    data: brandVenues,
    isLoading: isBrandVenuesLoading,
    isSuccess,
    error: brandVenuesError,
  } = useQuery(
    [`${MERCHANT_ENTERPRISE_SERVICE}/brands/${brand?.id}/venues`],
    () => brand && fetchBrandVenues(brand?.id),
    {
      refetchOnMount: false,
    },
  );

  const venueIds = brandVenues?.map(item => item.venueId) || [];

  const {
    data: venues = [],
    isLoading: isVenuesLoading,
    error: venuesError,
  } = useQuery({
    queryKey: ['fetchVenuesData', venueIds],
    queryFn: () => fetchVenuesData(venueIds),
    enabled: isSuccess,
  });

  return {
    venues,
    error: venuesError || brandVenuesError,
    isLoading: isBrandVenuesLoading || isVenuesLoading,
  };
}
